/* eslint-disable no-case-declarations */

import * as types from "./newsType";
const initialState = {
  loading: true,
  listNews: [],
  listNewsBanner: [],
  totalData: 0
};

export default function locale(state = initialState, action = {}) {
  switch (action.type) {
    case types.COUNT_LIST_NEWS_SUCCESS:
      const { totalData } = action;
      return { ...state, totalData: totalData };

    case types.LIST_NEWS_BANNERS_SUCCESS:
      const { listNewsBanner } = action;
      return { ...state, listNewsBanner: listNewsBanner, loading: false };

    case types.LIST_NEWS_SUCCESS:
      const { listNews } = action;
      return { ...state, listNews: listNews, loading: false };

    default:
      return state;
  }
}
